module.exports = "/_next/static/images/vermont-fcfb707bc98b3f8eef467a88b2897213.svg";